import React from 'react';
import './App.css';
import { CV } from './pages/CV'
import 'bootstrap/dist/css/bootstrap.min.css'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import Preloader from './components/Preloader';
import { CustomEase } from 'gsap/CustomEase';
import { zanimationInit } from './utils/functions';
import { gsap } from 'gsap';
import Home from './pages/Home';

const router = createBrowserRouter([
    {
        path: '/',
        element: (
            <Home />
        )
    },
    {
        path: 'curriculom',
        element: <CV />
    },
])

function App() {
    React.useEffect(() => {
        gsap.registerPlugin(CustomEase)
        CustomEase.create('CubicBezier', '.77,0,.18,1');
        zanimationInit(gsap)
    }, [])

    return (
        <>
            <Preloader />
            <RouterProvider router={router} />
        </>
    )
}

export default App;
